import { Tooltip as ReactTooltip } from "react-tooltip";
import useTranslator from "../../hooks/useTranslator";
import SkorProtectShield from "../../assets/img/skor-protect-shield.png";
import CheckCircleIcon from "./CheckCircleIcon";

const SkorProtectSelector = ({ value, onChange }) => {
  const { _t } = useTranslator();

  return (
    <div className="sp-selector">
      {/* Skor Protect option */}
      <div
        className={`sp-option${value ? " sp-option--active" : ""}`}
        onClick={() => onChange(true)}
      >
        <span className={`sp-radio${value ? " sp-radio--active" : ""}`} />
        <div className="sp-body">
          <div className="sp-header">
            <img src={SkorProtectShield} alt="" className="sp-shield" />
            <span className="sp-title">{_t("skorProtectTitle")}</span>
            <span className="sp-badge">{_t("recommended")}</span>
          </div>

          <p className="sp-desc">{_t("skorProtectDesc")}</p>

          <ul className="sp-benefits">
            <li>
              <CheckCircleIcon />
              <span>
                <strong>{_t("skorBenefit1Bold")}</strong>
                {" - "}
                {_t("skorBenefit1Rest")}
              </span>
            </li>
            <li>
              <CheckCircleIcon />
              <span>
                <strong>{_t("skorBenefit2Bold")}</strong>
                {" - "}
                {_t("skorBenefit2Rest")}
              </span>
            </li>
            <li>
              <CheckCircleIcon />
              <span>
                <strong>{_t("skorBenefit3Bold")}</strong>
                {" - "}
                {_t("skorBenefit3Rest")}
              </span>
            </li>
          </ul>

          <p className="sp-pricing">
            {_t("skorNoChargeNow")}
            {" · "}
            <span
              className="sp-pricing-trigger"
              data-tooltip-id="skor-price-tooltip"
            >
              {_t("skorPriceConfirmed")}
            </span>
          </p>
        </div>
      </div>

      {/* Continue without Skor Protect */}
      <div
        className={`sp-option sp-option--plain${!value ? " sp-option--active" : ""}`}
        onClick={() => onChange(false)}
      >
        <span className={`sp-radio${!value ? " sp-radio--active" : ""}`} />
        <div className="sp-body">
          <span className="sp-plain-title">
            {_t("continueWithoutSkorProtect")}
          </span>
          <p className="sp-plain-desc">
            {_t("continueWithoutSkorProtectDesc")}
          </p>
        </div>
      </div>

      <ReactTooltip
        id="skor-price-tooltip"
        place="top"
        noArrow
        className="react-tooltip-styling sp-price-tooltip"
        render={() => (
          <span className="sp-price-tooltip-text">
            {_t("skorPriceTooltip")}
          </span>
        )}
      />
    </div>
  );
};

export default SkorProtectSelector;
